module.exports = __webpack_public_path__ + "img/icon-jam-grey.96af574f.svg";